import { render, staticRenderFns } from "./ActivosInformacion.vue?vue&type=template&id=51b92893&"
import script from "./ActivosInformacion.vue?vue&type=script&lang=js&"
export * from "./ActivosInformacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports